import React from "react";
import { Flip, ToastContainer } from "react-toastify";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import 'react-medium-image-zoom/dist/styles.css'

import NewContextProvider from "./Context/NewContext";

import ProtectedRoutes from "./Components/ProtectedRoutes/ProtectedRoutes";
import ConfirmationModal from "./Components/Modals/ConfirmationModal";

import SignIn from "./Pages/SignIn/SignIn";
import Layout from "./Components/Layout/Layout";
import Dashboard from "./Pages/Dashboard/Dashboard";
import NotFound from "./Pages/NotFound/NotFound";
import Preview from "./Pages/Preview/Preview";

import { Themes, ThemesForm, ThemeCategories, ThemeCategoriesForm, TagsForm, ThemeTags } from './Pages/Themes'
import { Sliders, SliderForm, SliderTags, SliderTagsForm } from './Pages/Sliders'
import { Background, BackgroundForm, BackgroundCategories, BackgroundCategoriesForm, Effects, EffectsForm, FontList, FontListForm } from "./Pages/DIYs";
import { Sounds, SoundsForm } from "./Pages/Sounds";
import { StickerStore, StickerStoreForm } from "./Pages/StickerStore";
import { Wallpaper, WallpaperCategories, WallpaperCategoriesForm, WallpaperForm } from "./Pages/Wallpaper";
import History from "./Pages/History/History";

const App = () => {
  return (
    <>
      <ToastContainer position="bottom-center" transition={Flip} hideProgressBar={true} pauseOnFocusLoss={false} autoClose={1000} style={{ zIndex: "9999999" }} theme="dark" />
      <NewContextProvider>
        <Router>
          <Routes>
            <Route exact path="/" element={<ProtectedRoutes />}>
              <Route element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route exact path="/dashboard" element={<Dashboard />} />

                {/* SLIDER ROUTES */}
                <Route exact path="/sliders" element={<Sliders />} />
                <Route exact path="/sliderform" element={<SliderForm />} />
                <Route exact path="/slidertags" element={<SliderTags />} />
                <Route exact path="/slidertagsform" element={<SliderTagsForm />} />

                {/* THEMES ROUTES */}
                <Route exact path="/themes" element={<Themes />} />
                <Route exact path="/themesform" element={<ThemesForm />} />
                <Route exact path="/themecategories" element={<ThemeCategories />} />
                <Route exact path="/themecategoriesform" element={<ThemeCategoriesForm />} />
                <Route exact path="/themetags" element={<ThemeTags />} />
                <Route exact path="/themetagsform" element={<TagsForm />} />

                {/* DIYs ROUTES */}
                <Route exact path="/background" element={<Background />} />
                <Route exact path="/backgroundform" element={<BackgroundForm />} />
                <Route exact path="/backgroundcategories" element={<BackgroundCategories />} />
                <Route exact path="/backgroundcategoriesform" element={<BackgroundCategoriesForm />} />
                <Route exact path="/effects" element={<Effects />} />
                <Route exact path="/effectsform" element={<EffectsForm />} />
                <Route exact path="/fontlist" element={<FontList />} />
                <Route exact path="/fontlistform" element={<FontListForm />} />

                {/* SOUNDS ROUTES */}
                <Route exact path="/sounds" element={<Sounds />} />
                <Route exact path="/soundsform" element={<SoundsForm />} />

                {/* STICKERSTORE ROUTES */}
                <Route exact path="/stickerstore" element={<StickerStore />} />
                <Route exact path="/stickerstoreform" element={<StickerStoreForm />} />

                {/* DIYs ROUTES */}
                <Route exact path="/wallpaper" element={<Wallpaper />} />
                <Route exact path="/wallpaperform" element={<WallpaperForm />} />
                <Route exact path="/wallpapercategories" element={<WallpaperCategories />} />
                <Route exact path="/wallpapercategoriesform" element={<WallpaperCategoriesForm />} />

                {/* HISTORY ROUTES */}
                <Route exact path="/history" element={<History />} />

              </Route>
            </Route>
            <Route exact path="/preview" element={<Preview />} />
            <Route
              exact
              path="/signin"
              element={
                localStorage.getItem("token") ? (
                  <Navigate to={"/"} />
                ) : (<SignIn />)
              }
            />
            <Route exact path="/notfound" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/notfound" />} />
          </Routes>

          <ConfirmationModal />
        </Router>
      </NewContextProvider>
    </>
  );
};

export default App;
